import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { classNames } from "../../utils/helpers";
import s from './Text.module.css';
export const Text = (props) => {
    const { align, as: TagName = 'div', attributes, children, className, color, decoration, fontFamily, fontStyle, lineHeight, maxLines, size, textCase, variant, weight, } = props;
    const getSize = () => {
        if (color === 'on-accent' && (!size || parseInt(size, 10) < 125)) {
            // console.warn('on-accent color must be 18px or larger for ADA compliance')
            return { '--st-text-size': 'var(--st-font-size-125)' };
        }
        if (size) {
            return { '--st-text-size': `var(--st-font-size-${size})` };
        }
        else {
            return {};
        }
    };
    const rootClassName = classNames(s.root, variant && s[`--variant-${variant}`], maxLines !== undefined && s[`--clamp`], className);
    // TODO: May need to extend React.CSSProperties in order to properly use it with custom properties
    const passedStyle = (attributes === null || attributes === void 0 ? void 0 : attributes.style) || {};
    const style = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, passedStyle), { '--st-text-ml': maxLines }), (align && { '--st-text-align': align })), (color && { '--st-text-color': `var(--st-color-${color})` })), (weight && { '--st-text-weight': `var(--st-font-weight-${weight})` })), (decoration && { '--st-text-decoration': decoration })), (fontFamily && { '--st-text-font-family': `var(--st-font-family-${fontFamily})` })), (fontStyle && { '--st-text-style': fontStyle })), (textCase && { '--st-text-case': textCase })), getSize()), (lineHeight && { '--st-text-line-height': parseInt(lineHeight, 10) / 100 }));
    return (
    // @ts-expect-error TS throws an error due to the type complexity.
    // It still resolves the attributes correctly based on the tag
    _jsx(TagName, Object.assign({ "data-testid": "st-text" }, attributes, { className: rootClassName, style: style, children: children })));
};
